/**
 * 人工提问工具条右侧 · 计划状态（判定卡 04 差异 2；PR3 新写）：读 E-01 plan_view。
 * 挂起问题（本轮问的那件 ＋ 等客户类型）、事项进度（含未激活事项，灰显激活时机，D-27）。
 * 结构对齐 S3：焦点（对象一律来自事项绑定）、未计划诉求、转人工冻结整份计划都已退出，随之删。
 */
import { Badge } from "@/components/ui/badge";
import type { PlanView } from "@/lib/api/plan-lab";
import { useDemandLabel } from "../kit/demand-label";
import {
	ITEM_STATUS_TONE,
	ITEM_STATUS_ZH,
	WAIT_KIND_ZH,
	activationText,
	zh,
} from "../kit/plan-labels";

export function PlanStatus({ view }: { view: PlanView | null }) {
	const demandLabel = useDemandLabel();
	const asked = view?.items.find((i) => i.item_id === view.asked_item_id);
	return (
		<div className="ml-auto flex min-w-0 flex-col items-end gap-1.5" data-testid="plan-status">
			<div className="flex flex-wrap items-center justify-end gap-2 text-xs">
				{asked ? (
					<Badge tone="info">
						挂起 · {asked.item_id} {zh(WAIT_KIND_ZH, asked.wait_kind)}
					</Badge>
				) : (
					<Badge tone="muted">无挂起</Badge>
				)}
			</div>
			{view?.items.length ? (
				<div className="flex flex-wrap justify-end gap-1.5" data-testid="plan-items">
					{view.items.map((it) => (
						<span
							key={it.item_id}
							data-testid="plan-item-chip"
							data-active={it.active ? "1" : "0"}
							className={it.active ? undefined : "opacity-60"}
							title={it.status_reason ? JSON.stringify(it.status_reason) : undefined}
						>
							<Badge tone={it.active ? (ITEM_STATUS_TONE[it.status] ?? "muted") : "neutral"}>
								{it.item_id} {demandLabel(it.demand_type)} ·{" "}
								{it.active
									? `${zh(ITEM_STATUS_ZH, it.status)}${it.wait_kind ? `（${zh(WAIT_KIND_ZH, it.wait_kind)}）` : ""}`
									: `未激活 · ${activationText(it.activation)}`}
							</Badge>
						</span>
					))}
				</div>
			) : null}
		</div>
	);
}
